import { useEffect } from 'react';

const useReveal = () => {
    useEffect(() => {
        const reveals = document.querySelectorAll(".reveal");
        
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("active");
                    } else {
                        // Remove the class when it leaves the viewport to allow re-animation
                        entry.target.classList.remove("active");
                    }
                });
            },
            { 
                threshold: 0.1,
                // Add some rootMargin to make it trigger slightly before/after entering viewport
                rootMargin: "0px 0px -50px 0px"
            }
        );

        reveals.forEach((reveal) => {
            observer.observe(reveal);
        });

        return () => {
            reveals.forEach((reveal) => {
                observer.unobserve(reveal);
            });
        };
    }, []);
};

export default useReveal;
